import styled from 'styled-components';
import get from 'lodash-es/get';
export const ToastWrapper = styled.div `
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 1rem;
  margin-top: .5rem;
  width: 100%;
  color: white;
  max-width: 330px;
  pointer-events: all;
  display: flex;
  flex-flow: row nowrap;
  cursor: pointer;
  background-color: ${props => get(props.theme.colors, props.theme.notificationColors[props.type].bg, props.theme.notificationColors[props.type].bg) || 'primary'};
  color: ${props => get(props.theme.colors, props.theme.notificationColors[props.type].color, props.theme.notificationColors[props.type].color) || 'white'};
  border: 1px solid ${props => { var _a, _b; return ((_a = props.theme.notificationColors[props.type]) === null || _a === void 0 ? void 0 : _a.border) || ((_b = props.theme.notificationColors[props.type]) === null || _b === void 0 ? void 0 : _b.bg) || props.theme.colors.primary; }}
`;
export const ToastIcon = styled.div `
  padding: .5rem;
`;
export const ToastContent = styled.div `
  padding: .5rem;
`;
